var _defs, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQr2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 145.5,
    height: 145.5,
    viewBox: "0 0 145.5 145.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 21.35,
    y1: 124.15,
    x2: 124.15,
    y2: 21.35,
    gradientTransform: "translate(121.3 -17.96) rotate(73.15)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9748a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d163ab"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 36.18,
    y1: 109.32,
    x2: 109.32,
    y2: 36.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#edbede"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 72.75,
    cy: 72.75,
    r: 72.75,
    transform: "translate(-17.96 121.3) rotate(-73.15)",
    fill: "url(#a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.4,35.45H38a2.5,2.5,0,0,0-2.5,2.5V67.4A2.5,2.5,0,0,0,38,69.9H67.4a2.5,2.5,0,0,0,2.5-2.5V38A2.5,2.5,0,0,0,67.4,35.45ZM64.9,64.9H40.45V40.45H64.9Zm2.5,10.71H38a2.49,2.49,0,0,0-2.5,2.5v29.44a2.5,2.5,0,0,0,2.5,2.5H67.4a2.5,2.5,0,0,0,2.5-2.5V78.11A2.49,2.49,0,0,0,67.4,75.61Zm-2.5,29.44H40.45V80.61H64.9ZM47.1,60.74H58.24a2.5,2.5,0,0,0,2.5-2.5V47.1a2.5,2.5,0,0,0-2.5-2.5H47.1a2.5,2.5,0,0,0-2.5,2.5V58.24A2.5,2.5,0,0,0,47.1,60.74ZM49.6,49.6h6.14v6.14H49.6Zm58-14.15H78.1A2.5,2.5,0,0,0,75.6,38V67.4a2.5,2.5,0,0,0,2.5,2.5h29.45a2.5,2.5,0,0,0,2.5-2.5V38A2.5,2.5,0,0,0,107.55,35.45Zm-2.5,29.45H80.6V40.45h24.45Zm5,42.65a2.5,2.5,0,0,1-2.5,2.5h-6.21a2.5,2.5,0,0,1,0-5h6.21A2.5,2.5,0,0,1,110.05,107.55Zm-14.72,0a2.5,2.5,0,0,1-2.5,2.5H86.62a2.5,2.5,0,0,1,0-5h6.21A2.5,2.5,0,0,1,95.33,107.55Zm14.72-9.61a2.5,2.5,0,0,1-2.5,2.5H86.62a2.5,2.5,0,0,1,0-5h20.93A2.5,2.5,0,0,1,110.05,97.94ZM80.6,88.32v19.23a2.5,2.5,0,0,1-5,0V88.32a2.5,2.5,0,0,1,5,0Zm-5-10.21a2.49,2.49,0,0,1,2.5-2.5H97.33a2.5,2.5,0,0,1,0,5H78.1A2.5,2.5,0,0,1,75.6,78.11Zm34.45,0V88.32a2.5,2.5,0,0,1-2.5,2.5H86.45a2.5,2.5,0,1,1,0-5h18.6V78.11a2.5,2.5,0,0,1,5,0Z",
    fill: "url(#b)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr2);
export default __webpack_public_path__ + "static/media/qr-2.16e65ece82538907a3c3b8d2da2f1125.svg";
export { ForwardRef as ReactComponent };